import { jsx as n, Fragment as F, jsxs as D } from "react/jsx-runtime";
import { useRef as c, useState as P, useEffect as O, useCallback as u } from "react";
import W from "./CarouselUtils.class.js";
import { CarouselSlide as J } from "../CarouselSlide/CarouselSlide.js";
import { chunkArray as Q, classes as y } from "../../utils/helpers.js";
import { C as X } from "../../chevron-left-DmvQntvu.mjs";
import { C as Y } from "../../chevron-right-CaAz6ISN.mjs";
import '../../assets/Pagination.css';const Z = "_carousel_1booq_1", ee = "_carousel__scroller_1booq_11", a = {
  carousel: Z,
  carousel__scroller: ee,
  "carousel-controls": "_carousel-controls_1booq_38",
  "carousel-controls__btn": "_carousel-controls__btn_1booq_42",
  "carousel-controls__previous": "_carousel-controls__previous_1booq_67",
  "carousel-controls__next": "_carousel-controls__next_1booq_74",
  "carousel-nav": "_carousel-nav_1booq_86",
  "carousel-nav__list": "_carousel-nav__list_1booq_90",
  "carousel-nav__item": "_carousel-nav__item_1booq_99"
}, re = window.matchMedia("(max-width: 600px)"), te = window.matchMedia("(max-width: 800px"), le = window.matchMedia("(max-width: 1024px"), oe = window.matchMedia("(max-width: 1280px");
function fe({
  id: A,
  slides: z,
  options: x = {
    paginationType: "dots",
    showControls: !0,
    controlArrowSize: 48,
    controlButtonsOffset: 12,
    showScrollbar: !1,
    startIndex: 0,
    variableHeight: !1,
    title: "",
    autoplay: !1,
    autoplayDelay: 3500,
    showPagination: !1,
    gutterSize: 25,
    slideAspectRatio: "4/2",
    slideGap: 1.5,
    cellsPerSlide: 1,
    cellAspectRatio: "4/2",
    cellsPosition: "center",
    wrapAround: !0
  }
}) {
  const _ = c(`carousel-${A}`), R = c(null), i = c(null), I = c(null), m = c(z), E = c(null), S = c(null), l = c(null), e = c(x), $ = c(x.showPagination), T = c("-50%"), [N, V] = P([]), [t, d] = P(null), [k, j] = P([]);
  O(() => {
    ((o = null) => {
      re.matches ? (d({
        ...e.current,
        showControls: !1,
        showPagination: !1,
        cellsPerSlide: 1,
        cellsPosition: e.current.wrapAround ? "center" : "flex-start",
        gutterSize: 10
      }), e.current = {
        ...e.current,
        showControls: !1,
        showPagination: !1,
        cellsPerSlide: 1,
        cellsPosition: e.current.wrapAround ? "center" : "flex-start",
        gutterSize: 10
      }, $.current = !1) : te.matches ? e.current.cellsPerSlide > 2 ? (d({
        ...e.current,
        cellsPerSlide: 2,
        showControls: !1,
        gutterSize: 10
      }), e.current = {
        ...e.current,
        cellsPerSlide: 2,
        showControls: !1,
        gutterSize: 10
      }) : (d({
        ...e.current,
        showControls: !1,
        gutterSize: 10
      }), e.current = {
        ...e.current,
        showControls: !1,
        gutterSize: 10
      }) : le.matches ? e.current.cellsPerSlide > 3 ? (d({
        ...e.current,
        cellsPerSlide: 3,
        showControls: !1,
        gutterSize: 10
      }), e.current = {
        ...e.current,
        cellsPerSlide: 3,
        showControls: !1,
        gutterSize: 10
      }) : (d({
        ...e.current,
        showControls: !1,
        gutterSize: 10
      }), e.current = {
        ...e.current,
        showControls: !1,
        gutterSize: 10
      }) : oe.matches && e.current.showPagination ? (d({
        ...e.current,
        showControls: !1
      }), e.current = {
        ...e.current,
        showControls: !1
      }) : d({
        ...e.current
      });
    })();
  }, []);
  const L = u((r, o) => {
    const f = Q(o, r);
    j([...f]);
    let h = [];
    for (let s = 0; s <= f.length - 1; s++) {
      h[s] = {}, h[s].ariaLabel = `${s + 1} of ${f.length}`, h[s].layout = f[s][0].layout, h[s].cells = [];
      for (let w = 0; w <= f[s].length - 1; w++)
        h[s].cells[w] = {
          props: f[s][w].props
        };
    }
    const C = [...h], b = [...h], U = C.slice(-1), K = C.slice(0);
    return b.push(K[0]), b.unshift(U[0]), e.current.wrapAround && r.length > o ? b : C;
  }, []), p = u(() => {
    e.current.autoplay && l.current.clearTimer();
  }, []), B = u((r) => {
    p();
    const o = r.key;
    o === "ArrowLeft" ? (r.preventDefault(), l.current.determineScrollAction(-1)) : o === "ArrowRight" && (r.preventDefault(), l.current.determineScrollAction(1));
  }, [p]), G = u((r) => {
    p(), i.current.addEventListener("scrollend", () => {
      l.current.handleScrollEnd();
    }, { once: !0 });
  }, [p]), g = u((r) => {
    p(), i.current.addEventListener("scrollend", () => {
      l.current.handleScrollEnd(), i.current.addEventListener("scroll", g, { once: !0 });
    }, { once: !0 });
  }, [p]), H = () => {
    l.current && e.current.autoplay && l.current.clearTimer();
  }, v = u(() => {
    //! make sure class is only instantiated once because of reacts
    //! "strict" mode double do hocus pocus
    l.current === null && (l.current = new W({
      carouselEl: R.current,
      scrollerEl: i.current,
      paginationEl: I.current,
      slides: m.current,
      navBtnEls: {
        next: E.current,
        previous: S.current
      },
      id: _.current,
      options: {
        autoplay: e.current.autoplay,
        wrapAround: e.current.wrapAround && m.current.length > e.current.cellsPerSlide,
        showPagination: e.current.showPagination,
        delay: e.current.autoplayDelay,
        slideGutterSize: e.current.gutterSize,
        slideAspectRatio: e.current.slideAspectRatio,
        showControls: e.current.showControls && m.current.length > e.current.cellsPerSlide,
        cellsPerSlide: e.current.cellsPerSlide
      }
    }));
  }, []), M = u(() => {
    i.current.addEventListener("scroll", g, { once: !0 });
  }, [g]), q = u(() => {
    if (V(L(m.current, e.current.cellsPerSlide)), m.current.length > e.current.cellsPerSlide) {
      let r = setInterval(() => {
        i.current !== null && (S.current !== null && e.current.showControls || !e.current.showControls) && (clearInterval(r), M(), v());
      }, 100);
    } else {
      let r = setInterval(() => {
        i.current !== null && (clearInterval(r), v());
      }, 100);
    }
  }, [L, M, v]);
  return O(() => {
    if (t !== null) {
      if (t.showControls) {
        let r = 0;
        t.showPagination && (r = r + 25), t.showScrollbar && (r = r + 6), T.current = `calc(-50% - ${r}px)`;
      }
      q();
    }
    return () => {
      H();
    };
  }, [q, t]), /* @__PURE__ */ n(F, { children: t !== null && /* @__PURE__ */ D(
    "div",
    {
      className: a.carousel,
      id: _.current,
      ref: R,
      tabIndex: -1,
      role: "region",
      "aria-roledescription": "carousel",
      "aria-label": t.title,
      onKeyDown: B,
      style: {
        "--_carousel-gutters": t.wrapAround ? `${t.gutterSize <= 25 ? t.gutterSize : 25}%` : `0 ${t.gutterSize <= 25 ? t.gutterSize : 25}%`,
        "--_slide-aspect-ratio": t.slideAspectRatio,
        "--_cell-aspect-ratio": t.cellAspectRatio,
        "--_slide-cell-size": `${100 / t.cellsPerSlide}%`,
        "--_cells-position": t.cellsPosition,
        "--_control-btns-offset-x": `${t.controlButtonsOffset}rem`,
        "--_slide-gap": `${t.slideGap}rem`,
        "--_controls-transform": T.current
      },
      children: [
        /* @__PURE__ */ n(
          "ol",
          {
            className: a.carousel__scroller,
            ref: i,
            role: "group",
            "aria-label": "Items Scroller",
            "aria-live": "Polite",
            tabIndex: 0,
            onMouseEnter: (r) => {
              e.current.autoplay && l.current !== null && l.current.clearTimer();
            },
            onMouseLeave: (r) => {
              e.current.autoplay && l.current !== null && l.current.startTimer();
            },
            onTouchStart: G,
            "data-scrollbar": t.showScrollbar,
            children: N.length > 0 && N.map((r, o) => /* @__PURE__ */ n(
              J,
              {
                slide: r,
                index: o,
                currentIndex: t.wrapAround ? 1 : 0,
                variableHeight: t.variableHeight
              },
              `carousel${A}-slide${o}`
            ))
          }
        ),
        t.showControls && z.length > e.current.cellsPerSlide && /* @__PURE__ */ D("div", { className: a["carousel-controls"], children: [
          /* @__PURE__ */ n(
            "button",
            {
              type: "button",
              ref: S,
              title: "Previous Item",
              className: y([a["carousel-controls__btn"], a["carousel-controls__previous"], "carousel-controls__previous"]),
              "aria-controls": _.current,
              "aria-label": "Previous Item",
              onClick: (r) => {
                l.current.determineScrollAction(-1);
              },
              onMouseEnter: (r) => {
                e.current.autoplay && l.current !== null && l.current.clearTimer();
              },
              onMouseLeave: (r) => {
                e.current.autoplay && l.current !== null && l.current.startTimer();
              },
              children: /* @__PURE__ */ n("i", { "aria-hidden": "true", children: /* @__PURE__ */ n(X, { width: t.controlArrowSize, height: t.controlArrowSize }) })
            }
          ),
          /* @__PURE__ */ n(
            "button",
            {
              type: "button",
              ref: E,
              title: "Next Item",
              className: y([a["carousel-controls__btn"], a["carousel-controls__next"], "carousel-controls__next"]),
              "aria-controls": _.current,
              "aria-label": "Next Item",
              onClick: (r) => {
                l.current.determineScrollAction(1);
              },
              onMouseEnter: (r) => {
                e.current.autoplay && l.current !== null && l.current.clearTimer();
              },
              onMouseLeave: (r) => {
                e.current.autoplay && l.current !== null && l.current.startTimer();
              },
              children: /* @__PURE__ */ n("i", { "aria-hidden": "true", children: /* @__PURE__ */ n(Y, { width: t.controlArrowSize, height: t.controlArrowSize }) })
            }
          )
        ] }),
        $.current && k.length > 1 && /* @__PURE__ */ n("div", { className: [a["carousel-nav"], "carousel-nav"].join(" "), children: /* @__PURE__ */ n("ol", { className: a["carousel-nav__list"], ref: I, children: k.map((r, o) => /* @__PURE__ */ n(
          "li",
          {
            className: y([a["carousel-nav__item"], "carousel-nav__item"]),
            "data-current": o === 0 ? "true" : "false",
            onClick: (f) => {
              l.current.navigateToIndex(o);
            },
            title: `Navigate to slide ${o + 1}`
          },
          `carousel${_}-nav-${o}`
        )) }) })
      ]
    }
  ) });
}
export {
  fe as Carousel,
  fe as default
};
